import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FAQ() {
  const faqs = [{
    q: '¿Sirve si recién estoy arrancando como docente?',
    a: 'Sí. El Tomo 1 empieza desde los fundamentos absolutos y cada tomo tiene una lógica didáctica progresiva. Pensado tanto para docentes que inician como para los que quieren profesionalizar su material con contexto argentino actualizado al 2026.'
  }, {
    q: '¿Cómo recibo el material?',
    a: 'Apenas confirmado el pago recibís un link de descarga directa. Acceso inmediato en menos de 5 minutos. PDFs de alta calidad optimizados para pantalla o impresión.'
  }, {
    q: '¿El Upsell Premium es necesario?',
    a: 'Si solo querés mejorar tus clases con material técnico listo, el Megapack base es suficiente. Si además querés 120 secuencias listas para usar mañana mismo, 100 situaciones problemáticas argentinas y 80+ prompts de IA para generar material en minutos, el Upsell Premium es la mejor inversión de tu carrera.'
  }, {
    q: '¿Cuánto tiempo lleva implementarlo?',
    a: 'El primer día podés tener una actividad del Bono 1 aplicada en el aula. La mayoría de los docentes implementa cambios visibles en la primera semana.'
  }, {
    q: '¿La garantía es real?',
    a: 'Sí. Escribís a nuestro contacto dentro de los 7 días y te devolvemos el 100% sin preguntas. Tenemos menos del 1% de devoluciones porque el material cumple lo que promete.'
  }, {
    q: '¿Aplica para cualquier nivel educativo?',
    a: 'Sí. Secundario técnico, terciario o formación docente con orientación minera o industrial. También aplica para docentes de Geografía, Economía y Formación Ciudadana que quieren incorporar la minería argentina como contenido de soberanía económica.'
  }, {
    q: '¿Necesito conocimientos avanzados de minería para usarlo?',
    a: 'No. Cada tomo empieza desde lo conceptual con analogías claras y avanza con rigor técnico graduado. Si sos docente de ciencias técnicas sin especialización en minería, este material fue pensado especialmente para vos.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-20 bg-white" data-id="element-76">
      <div className="container mx-auto px-4 max-w-3xl" data-id="element-77">
        <h2 className="text-3xl font-extrabold text-center text-forest-dark mb-12" data-id="element-78">
          ❓ PREGUNTAS FRECUENTES
        </h2>

        <div className="space-y-4" data-id="element-79">
          {faqs.map((faq, i) => <div key={i} className="border border-sand rounded-2xl overflow-hidden bg-base" data-id="element-80">
              <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full px-6 py-5 text-left flex items-center justify-between focus:outline-none focus-visible:ring-2 focus-visible:ring-gold" aria-expanded={openIndex === i} data-id="element-81">
                <span className="font-bold text-forest-dark pr-4" data-id="element-82">{faq.q}</span>
                <ChevronDown className={`w-5 h-5 text-muted transition-transform duration-300 shrink-0 ${openIndex === i ? 'rotate-180' : ''}`} data-id="element-83" />
              </button>

              <AnimatePresence data-id="element-84">
                {openIndex === i && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-85">
                    <div className="px-6 pb-5 text-muted leading-relaxed border-t border-sand pt-3" data-id="element-86">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}